import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import MemberToggle from 'client/components/member/memberToggle';

const propTypes = {
  members: PropTypes.arrayOf(PropTypes.object).isRequired,
  appMembers: PropTypes.arrayOf(PropTypes.object),
  changeHandler: PropTypes.func,
};

const defaultProps = {
  changeHandler: () => {},
  appMembers: [],
};

class RenderSelectMembers extends Component {
  toggleMember(member) {
    const currentAppMembers = this.props.appMembers;
    const isInApp = _.some(currentAppMembers, { id: member.id });
    let selectedMembers;
    if (isInApp) {
      selectedMembers = _.filter(currentAppMembers, m => m.id !== member.id);
    } else {
      selectedMembers = currentAppMembers.concat(member);
    }
    this.props.changeHandler(selectedMembers);
  }

  render() {
    const { members } = this.props;

    return (
      <div className="members selection-items">
        {members.map(member => (
          <div key={member.id}>
            <MemberToggle
              member={member}
              required={member.type === 'primary'}
              checked={_.some(this.props.appMembers, { id: member.id })}
              clickHandler={(e) => {
                e.preventDefault();
                if (member.type !== 'primary') {
                  this.toggleMember(member);
                }
              }} />
          </div>
        ))}
      </div>
    );
  }
}

RenderSelectMembers.propTypes = propTypes;
RenderSelectMembers.defaultProps = defaultProps;
export default RenderSelectMembers;
